module.exports = __webpack_public_path__ + "static/media/circledivided2.13f4bd61.svg";